import React from "react";

export const Section = ({ title, eyebrow, action, children }) => (
  <section className="bg-white border border-zinc-200 mb-6">
    <header className="flex flex-wrap items-center justify-between gap-3 px-6 py-4 border-b border-zinc-200">
      <div>
        {eyebrow && <div className="text-[10px] tracking-[0.2em] uppercase font-bold text-zinc-500">{eyebrow}</div>}
        <h2 className="font-display font-bold text-xl mt-0.5">{title}</h2>
      </div>
      {action}
    </header>
    <div className="p-6">{children}</div>
  </section>
);

export const Stat = ({ label, value, accent }) => (
  <div className="bg-white border border-zinc-200 p-5">
    <div className="text-[10px] tracking-[0.2em] uppercase font-bold text-zinc-500">{label}</div>
    <div className="font-display font-black text-3xl mt-1" style={accent ? { color: accent } : {}}>{value}</div>
  </div>
);

export const Pill = ({ children, tone = "default" }) => {
  const tones = {
    default: "bg-zinc-100 text-zinc-800 border-zinc-200",
    blue:    "bg-[#0020F5]/10 text-[#0020F5] border-[#0020F5]/30",
    red:     "bg-[#FF3B30]/10 text-[#FF3B30] border-[#FF3B30]/30",
    orange:  "bg-[#FF9500]/10 text-[#FF9500] border-[#FF9500]/30",
    yellow:  "bg-[#FFD60A]/15 text-[#A16207] border-[#FFD60A]/60",
    green:   "bg-[#16A34A]/10 text-[#16A34A] border-[#16A34A]/40",
    teal:    "bg-[#00C7BE]/10 text-[#00C7BE] border-[#00C7BE]/30",
    black:   "bg-zinc-950 text-white border-zinc-950",
  };
  return (
    <span className={`inline-flex items-center px-2 h-6 text-[11px] tracking-[0.1em] uppercase font-bold border ${tones[tone] || tones.default}`}>
      {children}
    </span>
  );
};

/* Canonical severity → tone map. KEEP IN SYNC with SEVERITY_HEX below and the
   backend brief payload (server.py _build_brief_payload). */
export const severityTone = (s) => {
  switch ((s || "").toLowerCase()) {
    case "critical": return "red";
    case "high":     return "orange";
    case "medium":   return "yellow";
    case "low":      return "green";
    default:         return "default";
  }
};

/* Single source of truth for severity/urgency hex colors used by charts.
   Importing this from individual lenses avoids drift. */
export const SEVERITY_HEX = {
  critical: "#FF3B30",
  high:     "#FF9500",
  medium:   "#FFD60A",
  low:      "#16A34A",
};

export const EmptyState = ({ title, hint, testid }) => (
  <div className="text-center py-12" data-testid={testid}>
    <div className="font-display font-bold text-xl">{title}</div>
    <div className="text-sm text-zinc-500 mt-1">{hint}</div>
  </div>
);
